var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportmedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.42 5.47v-3c0-.33.26-.6.58-.6.29 0 .53.23.57.51v3.08h3.6a3.4 3.4 0 0 1 3.33 3.3V12.68a3.4 3.4 0 0 1-3.17 3.43h-8.5a3.38 3.38 0 0 1-3.33-3.28V8.91a3.4 3.4 0 0 1 3.17-3.44h3.75v4.8l-1.2-1.24a.57.57 0 0 0-.81 0 .6.6 0 0 0-.17.43c0 .11.03.24.1.34l.07.07 2.18 2.27c.1.11.25.17.41.17.13 0 .25-.04.35-.12l.05-.05 2.19-2.27a.61.61 0 0 0 0-.84.57.57 0 0 0-.76-.06l-.06.06-1.2 1.24v-4.8H8.43Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportmedium);
export default __webpack_public_path__ + "static/media/import.medium.2a51145d9e0b816bdf534889375894e4.svg";
export { ForwardRef as ReactComponent };